import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-60fe5a6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "modal"
}
const _hoisted_5 = { class: "contenedor" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Consulta", -1))
const _hoisted_7 = { class: "contenido" }
const _hoisted_8 = { class: "contenido" }
const _hoisted_9 = {
  key: 1,
  class: "modal7"
}
const _hoisted_10 = { class: "contenedor7" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Supervisores", -1))
const _hoisted_12 = { class: "contenido7" }
const _hoisted_13 = { class: "contenido7" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "general" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_17 = { class: "grid" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cod"
}, "Código:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nomb"
}, "Nombre:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "apell"
}, "Apellido:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sex"
}, "Sexo:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "M", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "F", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaNac"
}, "Fecha de Nacimiento:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad"
}, "Edad:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nacio"
}, "Nacionalidad:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cedu"
}, "Cédula:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "pass"
}, "Pasaporte:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telef"
}, "Teléfono:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "Dirección:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Empleado")
], -1))
const _hoisted_33 = { class: "grid" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "emp"
}, "Empresa:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "suc"
}, "Sucursal:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "dpto"
}, "Departamento:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "puest"
}, "Puesto:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "turn"
}, "Turno:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "ars"
}, "Aseguradora:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "iniVac"
}, "Inicio de Vacaciones:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "finVac"
}, "Fin de Vacaciones:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "noDepe"
}, "Número de Dependientes:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaCont"
}, "Fecha de Contratación:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "stat"
}, "Estatus:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Financieros")
], -1))
const _hoisted_46 = { class: "grid" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cuenta"
}, "Cuenta Bancaria:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "salario"
}, "Salario:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "otrsIngs"
}, "Otros Ingresos:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Notas")
], -1))
const _hoisted_51 = { class: "grid" }
const _hoisted_52 = { class: "grid-consultas" }
const _hoisted_53 = { style: {"font-weight":"bold"} }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "12",
                      id: "showInComentary",
                      type: "showInComentary",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentEdition.description) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.currentEdition.description]
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModal7)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalMethod72())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      type: "search",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                      class: "form-control",
                      onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscar()))
                    }, null, 544), [
                      [_vModelText, _ctx.search]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seguros2, (seguro, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "ars",
                        style: {"cursor":"pointer"},
                        key: index,
                        onClick: ($event: any) => (_ctx.setSeguro(seguro.nomb, seguro.apell))
                      }, _toDisplayString(seguro.nomb) + " " + _toDisplayString(seguro.apell), 9, _hoisted_14))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "cod",
                  type: "String",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.empleado.cod) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.cod]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  id: "nomb",
                  type: "String",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.empleado.nomb) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.nomb]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  id: "apell",
                  type: "String",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.empleado.apell) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.apell]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _withDirectives(_createElementVNode("select", {
                  id: "sex",
                  type: "String",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.empleado.sex) = $event)),
                  class: "form-select"
                }, _hoisted_24, 512), [
                  [_vModelSelect, _ctx.empleado.sex]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaNac",
                  type: "Date",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.calcularEdad(_ctx.empleado.fechaNac))),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.empleado.fechaNac) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.empleado.fechaNac]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "edad",
                  type: "Number",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.empleado.edad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.edad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  id: "nacio",
                  type: "String",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.empleado.nacio) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.nacio]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  id: "cedu",
                  type: "String",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.empleado.cedu) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.cedu]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  id: "pass",
                  type: "String",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.empleado.pass) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.pass]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  id: "telef",
                  type: "String",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.empleado.telef) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.telef]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  id: "direccion",
                  type: "String",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.empleado.direccion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.direccion]
                ])
              ])
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", null, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  id: "emp",
                  type: "String",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.empleado.emp) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.emp]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  id: "suc",
                  type: "String",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.empleado.suc) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.suc]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  id: "dpto",
                  type: "String",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.empleado.dpto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.dpto]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  id: "puest",
                  type: "String",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.empleado.puest) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.puest]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  id: "turn",
                  type: "String",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.empleado.turn) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.turn]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                  id: "ars",
                  type: "String",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.empleado.ars) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.ars]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  id: "iniVac",
                  type: "Date",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.empleado.iniVac) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.iniVac]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  id: "finVac",
                  type: "Date",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.empleado.finVac) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.finVac]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  id: "noDepe",
                  type: "Number",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.empleado.noDepe) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.noDepe]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaCont",
                  type: "Date",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.empleado.fechaCont) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.fechaCont]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  id: "stat",
                  type: "String",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.empleado.stat) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.stat]
                ])
              ])
            ]),
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", null, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  id: "cuenta",
                  type: "String",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.empleado.cuenta) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.cuenta]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  id: "salario",
                  type: "Number",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.empleado.salario) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.salario]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  id: "otrsIngs",
                  type: "String",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.empleado.otrsIngs) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.otrsIngs]
                ])
              ])
            ]),
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("textarea", {
                  rows: "5",
                  id: "notas",
                  type: "String",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.empleado.notas) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.empleado.notas]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empleado.consultas, (consulta, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "card-body"
                }, [
                  _createElementVNode("p", _hoisted_53, [
                    _createTextVNode(" No. " + _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.newFormatDate(consulta.date)) + " ", 1),
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.deleteService(index)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-minus-circle redOption"
                    }, null, 8, _hoisted_54),
                    _hoisted_55,
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.editService(index, consulta)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-edit greenOption"
                    }, null, 8, _hoisted_56)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(consulta.description), 1)
                ]))
              }), 128))
            ]),
            (this.modoForm == 'add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.saveEmpleado()), ["prevent"])),
                  disabled: 
                !_ctx.empleado.nomb ||
                  !_ctx.empleado.apell ||
                  !_ctx.empleado.finVac ||
                  !_ctx.empleado.iniVac ||
                  !_ctx.empleado.fechaNac ||
                  !_ctx.empleado.fechaCont
              
                }, _hoisted_60, 8, _hoisted_57))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success",
                  onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.empleado.nomb ||
                  !_ctx.empleado.apell ||
                  !_ctx.empleado.finVac ||
                  !_ctx.empleado.iniVac ||
                  !_ctx.empleado.fechaNac ||
                  !_ctx.empleado.fechaCont
              
                }, _hoisted_64, 8, _hoisted_61))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_67))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}